document.addEventListener("DOMContentLoaded", function () {
	const pdswc = document.querySelectorAll('[href*="#reopenBanner"]');
	for (var i = 0, l = pdswc.length; i < l; i++) {
		var el = pdswc[i];
		el.addEventListener('click', function(e){
			e.preventDefault();
			window.Pandectes.fn.openPreferences();
		});
	}
});
